import React from 'react';
import { currencyFormatter } from '@mooncake/utils/sfcc/currency';

interface IPrice {
  price: number;
  localeId: string;
  currency: string;
  content?: string;
  isDiscount?: boolean;
  isDiscountItem? : boolean;
}

const Price = ({ price, localeId, currency, content, isDiscount, isDiscountItem }: IPrice) => {
  const localeIdFormatted =
    localeId.indexOf('_') > 0
      ? localeId.replace('_', '-').toLowerCase()
      : localeId;

  const displayPrice = currencyFormatter(price, localeIdFormatted, currency);
  const contentWithPrice = () => {
    if (!content) {
      return displayPrice;
    }

    const regex = /\<\%PRICE\%\>/;
    return content.replace(regex, displayPrice);
  };
  return (
    <span
      className={`price${isDiscountItem ? ' discount-style ' : ' '}${isDiscount && !isDiscountItem ? 'discount-main-price' : ''}`}
      dangerouslySetInnerHTML={{ __html: contentWithPrice() }}
    />
  );
};

export default Price;
